export default "__VITE_PUBLIC_ASSET__0cfa8352__"